import { render, staticRenderFns } from "./CampusSelect.vue?vue&type=template&id=188aa3b7&scoped=true"
import script from "./CampusSelect.vue?vue&type=script&lang=js"
export * from "./CampusSelect.vue?vue&type=script&lang=js"
import style0 from "./CampusSelect.vue?vue&type=style&index=0&id=188aa3b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188aa3b7",
  null
  
)

export default component.exports